module.exports = __webpack_public_path__ + "img/title.61db2c66.png";